import React, { Component, Fragment } from 'react';
import styled from 'styled-components';

import ScrollAnimation from 'components/ScrollAnimation';
import Header from 'components/Header';
import ContentBlock from 'src/components/ContentBlock';
import Panorama from './elements/Panorama/Panorama';
import NextLine from 'components/NextLine';
import RegisterButton from 'components/RegisterButton';

import imgHero from 'src/assets/images/views/hero.jpg';

class Views extends Component {
  render() {
    return (
      <Root>
        <Header image={imgHero} smallText={'Legendary'} largeText={'Views'} />
        <ContentBlockWrapper>
          <ScrollAnimation>
            <StyledContentBlock
              title="33 Storeys Above It All"
              body={
                <Fragment>
                  New Westminster has always been famous for its impressive
                  views. One of the city’s fathers described it as “Very
                  striking, a background of <strong>superb mountain</strong>
                  —Swiss in outline, dark in woods, grandly towering into the
                  clouds there is a{' '}
                  <strong>sublimity that deeply impresses you.</strong>” Today,
                  these same panoramic views are accessible to everyone—from the
                  magnificent <strong>North Shore Mountains</strong> and the{' '}
                  <strong>Fraser Valley</strong> in the east to the iconic{' '}
                  <strong>Mount Baker</strong> in the south, and the{' '}
                  <strong>Georgia Strait and Gulf Islands</strong> in the west.
                </Fragment>
              }
            />
          </ScrollAnimation>
        </ContentBlockWrapper>

        <ScrollAnimation>
          <Panorama />
        </ScrollAnimation>
        <ScrollAnimation>
          <NextLine text={'Next: The Team'} link={'/team'} />
          <RegisterButton />
        </ScrollAnimation>
      </Root>
    );
  }
}

const Root = styled.main`
  overflow-x: hidden;
`;

const ContentBlockWrapper = styled.div`
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: -275px;
    right: -275px;
    width: 550px;
    height: 550px;
    background-image: url(${require('src/assets/images/register/circle.svg')});
    background-size: cover;
    z-index: -1;
  }
  &::after {
    content: '';
    position: absolute;
    top: 100px;
    left: 0px;
    width: 400px;
    height: 400px;
    background-image: url(${require('src/assets/images/register/circle.svg')});
    background-size: cover;
    z-index: -1;
  }
`;

const StyledContentBlock = styled(ContentBlock)`
  padding: 75px 20px 40px;
`;

export default Views;



// WEBPACK FOOTER //
// ./src/pages/Views/Views.js